export const ARTICLES = 'articles';
export const PRODUCTS = 'products';
